import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Chip.module.scss'

export type ChipVariant = 'default' | 'primary' | 'success' | 'warning' | 'info' | 'violet' | 'danger'

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant
  leadingIcon?: ReactNode
  children?: ReactNode
}

export const Chip = forwardRef<HTMLSpanElement, ChipProps>(function Chip(
  { variant = 'default', leadingIcon, className, children, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={cn(styles.chip, styles[`variant-${variant}`], className)} {...rest}>
      {leadingIcon ? <span className={styles.icon} aria-hidden>{leadingIcon}</span> : null}
      {children}
    </span>
  )
})
